import * as React from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs from 'dayjs';

export default function EditDialog(props) {
    const { onSave, onClose, selectedValue, open } = props;

    const [orderNo, setOrderNo] = React.useState("");
    const [farmName, setFarmName] = React.useState("");
    const [quantity, setQuantity] = React.useState("");
    const [pickupDate, setPickupDate] = React.useState(dayjs(new Date()));

    React.useEffect(() => {
        if (selectedValue) {
            setOrderNo(selectedValue.order_no);
            setFarmName(selectedValue.farm_name);
            setQuantity(selectedValue.quantity);
            setPickupDate(dayjs(new Date(selectedValue.pickup_date)));
        }
    }, [selectedValue])

    const handleClose = () => {
        onClose();
    };

    const handleSave = () => {
        onSave({
            quantity: parseInt(quantity),
            pickup_date: new Date(pickupDate).toISOString()
        });
    }

    return (
        <Dialog onClose={handleClose} open={open}>
            <DialogTitle>{`Order #${orderNo}`}</DialogTitle>
            <Box
                // component="form"
                sx={{
                    '& .MuiTextField-root': { m: 1, width: '25ch' },
                }}
                noValidate
                autoComplete="off"
                style={{ padding: '0 24px' }}
            >
                <div>
                    <div>
                        <TextField
                            id="farm-name"
                            label="Farm Name"
                            defaultValue={farmName}
                            InputProps={{
                                readOnly: true,
                            }}
                        />
                    </div>
                    <div>
                        <TextField
                            id="quantity"
                            label="Quantity"
                            type="number"
                            value={quantity}
                            onChange={(e) => setQuantity(e.target.value)}
                        />
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DateTimePicker
                                label="PickUp Date"
                                value={pickupDate}
                                onChange={(e) => setPickupDate(e)}
                                slotProps={{ popper: { placement: 'right-start' } }} />
                        </LocalizationProvider>
                    </div>
                    <div style={{ margin: '10px', float: 'right' }}>
                        <button className="btn btn-primary success" style={{ marginRight: '10px' }} onClick={handleSave}>Save</button>
                        <button className="btn btn-primary success" onClick={() => handleClose()}>Cancel</button>
                    </div>
                </div>
            </Box>
        </Dialog>
    );
}
